import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { StruckTotal } from "./OrderSummary"
import styles from "./BookingForm.module.css"

// The order's promo code and total, under its experiences (Figma 5796:176503): "Add Promo-code"
// opens the promo field (`promoInput`, which also lists the applied code; none for an order of several
// experiences until its promo rules exist), then the Order Total.
// `children` follow it: what is charged now (card fee, deposit) and the subtotal adjustment.
const OrderTotal = ({ total, totalBeforeAdjustments, promoInput, isPromoApplied, children }) => {
  const { t } = useTranslation()
  const [isPromoOpen, setIsPromoOpen] = useState(false)
  return (
    <Flex vertical gap="var(--spacing-xs)" className={styles.orderTotalBox}>
      {promoInput &&
        (isPromoOpen || isPromoApplied ? (
          promoInput
        ) : (
          <Button type="link" className={styles.addPromoLink} onClick={() => setIsPromoOpen(true)}>
            {t("booking.order_summary.add_promo")}
          </Button>
        ))}
      <Flex justify="space-between" align="baseline" gap="var(--spacing-m)" className={styles.orderTotalRow}>
        <span>{t("booking.order_summary.order_total")}</span>
        <StruckTotal total={total} totalBeforeAdjustments={totalBeforeAdjustments} />
      </Flex>
      {children}
    </Flex>
  )
}

OrderTotal.propTypes = {
  total: PropTypes.number.isRequired,
  totalBeforeAdjustments: PropTypes.number,
  promoInput: PropTypes.node,
  isPromoApplied: PropTypes.bool,
  children: PropTypes.node
}

OrderTotal.defaultProps = {
  totalBeforeAdjustments: 0,
  promoInput: null,
  isPromoApplied: false,
  children: null
}

export default OrderTotal
